"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var connected_react_router_1 = require("connected-react-router");
var recompose_1 = require("recompose");
var react_select_1 = require("react-select");
var sok_ui_1 = require("@caddigital/sok-ui");
var Types = require("types");
var Icon_1 = require("components/Icon");
var copyActions = require("@caddigital/sok-reducers/lib/actions/project/copy");
var projects_1 = require("@caddigital/sok-reducers/lib/actions/projects");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var translate_1 = require("utils/translate");
require("./styles.scss");
var mapStateToProps = function (state) {
    return {
        copy: state.project.copy
    };
};
exports.mapStateToProps = mapStateToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var mapDispatchToProps = function (dispatch) { return ({
    toggleCopyModal: function (project) {
        if (project !== undefined) {
            dispatch((0, projects_1.toggleSelection)(project));
        }
        dispatch(copyActions.toggleCopyModal());
    },
    setSearchString: function (value) {
        if (value !== '') {
            dispatch(copyActions.searchCompanyRequest(value));
        }
    },
    fetchProjectTemplates: function () { return dispatch(copyActions.fetchTemplatesRequest()); },
    updateField: function (key, val) {
        dispatch(copyActions.updateField(key, val));
    },
    copyProject: function (params) {
        dispatch(copyActions.copyProjectRequest(params));
    },
    goToCopied: function (mode, copied, project) {
        return function () {
            copied &&
                dispatch((0, connected_react_router_1.push)("/".concat((0, translate_1.getLanguage)(), "/").concat(mode === 'COPY' ? 'admin/' : '', "projects/").concat(copied.id)));
            project && dispatch((0, projects_1.toggleSelection)(project));
            dispatch(copyActions.toggleCopyModal());
        };
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var ProjectSelect = /** @class */ (function (_super) {
    __extends(ProjectSelect, _super);
    function ProjectSelect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ProjectSelect;
}(react_select_1.default));
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('CopyProjectModal'), (0, recompose_1.withState)('templates', 'setTemplates', []), (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        if (this.props.copy.mode === 'TEMPLATE' && this.props.copy.isOpen) {
            var temp = this.props.copy.templates.reduce(function (acc, project) {
                var projects = acc[project.customerName || ''] || [];
                projects.push(project);
                acc[project.customerName || ''] = projects;
                return acc;
            }, {});
            var templates = Object.entries(temp).map(function (_a) {
                var customer = _a[0], projects = _a[1];
                return ({
                    label: customer,
                    options: projects
                });
            });
            this.props.setTemplates(templates);
        }
    },
    componentDidUpdate: function (prevProps) {
        if (this.props.copy.mode === 'TEMPLATE') {
            if (this.props.copy.isOpen !== prevProps.copy.isOpen) {
                if (this.props.copy.isOpen) {
                    this.props.fetchProjectTemplates();
                }
                else {
                    this.props.setTemplates([]);
                }
            }
            if (this.props.copy.isOpen &&
                this.props.copy.templates !== prevProps.copy.templates) {
                var temp = this.props.copy.templates.reduce(function (acc, project) {
                    var projects = acc[project.customerName || ''] || [];
                    projects.push(project);
                    acc[project.customerName || ''] = projects;
                    return acc;
                }, {});
                var templates = Object.entries(temp).map(function (_a) {
                    var customer = _a[0], projects = _a[1];
                    return ({
                        label: customer,
                        options: projects
                    });
                });
                this.props.setTemplates(templates);
            }
        }
    },
    shouldComponentUpdate: function (nextProps) {
        return (nextProps.copy.isOpen ||
            nextProps.copy.isOpen !== this.props.copy.isOpen);
    }
}), recompose_1.pure);
function Content(props) {
    return (React.createElement(React.Fragment, null,
        React.createElement("h3", { key: 'title-1' }, (0, translation_1.getLocalization)('components/projectCopy/newInfo')),
        props.copy.mode === 'COPY' ? (React.createElement(sok_ui_1.Row, { key: 'row-1' },
            React.createElement(sok_ui_1.Column, { large: 12 },
                React.createElement("label", { htmlFor: 'company' },
                    React.createElement(Icon_1.Icon, { className: 'fa-building' }),
                    ' ',
                    (0, translation_1.getLocalization)('components/projectCopy/companyName')),
                React.createElement(react_select_1.default, { menuPlacement: 'auto', classNamePrefix: 'react-select', id: 'companyName', isLoading: props.copy.companiesStatus === 'FETCHING', value: props.copy.data.selectedCompany, options: props.copy.companies, isSearchable: true, getOptionValue: function (opt) { return opt.name; }, getOptionLabel: function (opt) { return opt.name; }, onInputChange: props.setSearchString, onChange: function (e) {
                        return props.updateField('selectedCompany', Array.isArray(e) && e.length === 0 ? undefined : e);
                    } }),
                props.copy.errors['selectedCompany'] && (React.createElement("p", { className: 'form-error' }, props.copy.errors['selectedCompany'][0]))))) : (React.createElement(sok_ui_1.Row, null,
            React.createElement(sok_ui_1.Column, { large: 12 },
                React.createElement("label", { htmlFor: 'template' },
                    React.createElement(Icon_1.Icon, { className: 'fa-window' }),
                    ' ',
                    (0, translation_1.getLocalization)('components/projectCopy/template')),
                React.createElement(ProjectSelect, { menuPlacement: 'auto', classNamePrefix: 'react-select', id: 'template', isLoading: props.copy.templatesStatus === 'FETCHING', value: props.copy.data.copyFrom, options: props.templates, isSearchable: true, getOptionValue: function (opt) { return opt.name; }, getOptionLabel: function (opt) { return opt.name; }, onChange: function (e) {
                        return props.updateField('copyFrom', Array.isArray(e) && e.length === 0 ? undefined : e);
                    } }),
                props.copy.errors['copyFrom'] && (React.createElement("p", { className: 'form-error' }, props.copy.errors['copyFrom'][0]))))),
        React.createElement(sok_ui_1.Row, { key: 'row-2' },
            React.createElement(sok_ui_1.Column, { large: 12 },
                React.createElement("label", { htmlFor: 'project' },
                    React.createElement(Icon_1.Icon, { className: 'fa-building' }),
                    ' ',
                    (0, translation_1.getLocalization)('components/projectCopy/projectName')),
                React.createElement(sok_ui_1.TextInput, { type: 'text', id: 'project', name: 'project', value: props.copy.data.projectName, onChange: function (e) { return props.updateField('projectName', e.target.value); }, className: 'white' }),
                props.copy.errors['projectName'] && (React.createElement("p", { className: 'form-error' }, props.copy.errors['projectName'][0])))),
        props.copy.mode === 'COPY' ? (React.createElement("h3", { key: 'title-2' }, (0, translation_1.getLocalization)('components/projectCopy/selectItems'))) : undefined,
        props.copy.mode === 'COPY' ? (React.createElement(React.Fragment, null,
            React.createElement(sok_ui_1.Row, { key: 'row-3' },
                React.createElement(sok_ui_1.Column, { small: 6 },
                    React.createElement(sok_ui_1.Input, { type: "checkbox", name: "folderStructure", label: (0, translation_1.getLocalization)('components/projectCopy/folderStructure'), onChange: function (e) {
                            return props.updateField('folderStructure', !props.copy.data.folderStructure);
                        }, value: props.copy.data.folderStructure })),
                React.createElement(sok_ui_1.Column, { small: 6 },
                    React.createElement(sok_ui_1.Input, { type: "checkbox", name: "userGroups", label: (0, translation_1.getLocalization)('components/projectCopy/userGroups'), onChange: function (e) {
                            return props.updateField('userGroups', !props.copy.data.userGroups);
                        }, value: props.copy.data.userGroups }))),
            React.createElement(sok_ui_1.Row, { key: 'row-4' },
                React.createElement(sok_ui_1.Column, { small: 6 },
                    React.createElement(sok_ui_1.Input, { type: "checkbox", name: "files", label: (0, translation_1.getLocalization)('components/projectCopy/files'), onChange: function (e) {
                            return props.updateField('files', !props.copy.data.files);
                        }, value: props.copy.data.files, disabled: !props.copy.data.folderStructure })),
                React.createElement(sok_ui_1.Column, { small: 6 },
                    React.createElement(sok_ui_1.Input, { type: "checkbox", name: "users", label: (0, translation_1.getLocalization)('components/projectCopy/users'), onChange: function (e) {
                            return props.updateField('users', !props.copy.data.users);
                        }, value: props.copy.data.users, disabled: !props.copy.data.userGroups }))))) : (React.createElement(sok_ui_1.Row, { key: 'row-3' },
            React.createElement(sok_ui_1.Column, { large: 12 },
                React.createElement("label", { htmlFor: 'projectDescription' },
                    React.createElement(Icon_1.Icon, { className: 'fa-comment-alt-lines' }),
                    ' ',
                    (0, translation_1.getLocalization)('components/projectCopy/projectDescription')),
                React.createElement(sok_ui_1.TextInput, { type: 'textarea', rows: 5, id: 'projectDescription', name: 'projectDescription', value: props.copy.data.projectDescription, onChange: function (e) {
                        return props.updateField('projectDescription', e.target.value);
                    }, className: 'white' }),
                props.copy.errors['projectDescription'] && (React.createElement("p", { className: 'form-error' }, props.copy.errors['projectDescription'][0])))))));
}
function Loading(props) {
    return (React.createElement("div", { className: 'spinner', key: 'spinner' },
        React.createElement(sok_ui_1.RequestSpinner, { isLoading: props.copy.status === 'COPYING', success: props.copy.status === 'COPIED' }),
        props.copy.status === 'COPYING' && (React.createElement("p", null, (0, translation_1.getLocalization)('components/projectCopy/copying'))),
        props.copy.status === 'COPIED' && (React.createElement("p", null, (0, translation_1.getLocalization)('components/projectCopy/copied'))),
        props.copy.status === 'FAILED' && (React.createElement("p", null, (0, translation_1.getLocalization)('components/projectCopy/failed')))));
}
exports.default = enhance(function (props) {
    return (React.createElement(sok_ui_1.Modal, { className: 'copy-project-modal', isOpen: props.copy.isOpen },
        React.createElement(sok_ui_1.Header, { onClose: function () {
                return props.copy.status !== 'COPYING' &&
                    props.toggleCopyModal(props.copy.data.copyFrom);
            } }, (0, translation_1.getLocalization)("components/projectCopy/".concat(props.copy.mode === 'TEMPLATE' ? 'template/' : '', "header"))),
        React.createElement(sok_ui_1.Container, null, props.copy.status === 'INITIAL'
            ? React.createElement(Content, props)
            : React.createElement(Loading, props)),
        React.createElement(sok_ui_1.Footer, null,
            props.copy.status === 'INITIAL' || props.copy.status === 'FAILED' ? (React.createElement(sok_ui_1.Button, { color: 'base-green', text: (0, translation_1.getLocalization)('buttons/copy'), onClick: function () {
                    if (props.copy.data.copyFrom === undefined) {
                        return;
                    }
                    if (props.copy.mode === 'TEMPLATE') {
                        props.copyProject({
                            type: props.copy.mode,
                            projectName: props.copy.data.projectName,
                            projectDescription: props.copy.data.projectDescription,
                            copyFrom: props.copy.data.copyFrom.id,
                            folderStructure: true,
                            files: true,
                            userGroups: true,
                            users: true
                        });
                    }
                    else {
                        props.copyProject({
                            type: props.copy.mode,
                            projectName: props.copy.data.projectName,
                            copyFrom: props.copy.data.copyFrom.id,
                            folderStructure: props.copy.data.folderStructure,
                            files: props.copy.data.files,
                            userGroups: props.copy.data.userGroups,
                            users: props.copy.data.users,
                            selectedCompanyId: props.copy.data.selectedCompany
                                ? props.copy.data.selectedCompany.id
                                : undefined
                        });
                    }
                }, disabled: props.copy.mode === 'COPY'
                    ? (!props.copy.data.files &&
                        !props.copy.data.userGroups &&
                        !props.copy.data.users &&
                        !props.copy.data.folderStructure) ||
                        props.copy.data.projectName.length < 1 ||
                        props.copy.data.selectedCompany === undefined
                    : props.copy.data.copyFrom === undefined ||
                        props.copy.data.projectName.length < 1 })) : (React.createElement(sok_ui_1.Button, { color: 'blue', text: (0, translation_1.getLocalization)('buttons/continue'), onClick: props.goToCopied(props.copy.mode, props.copy.copied, props.copy.data.copyFrom), disabled: props.copy.status !== 'COPIED' })),
            React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('buttons/close'), disabled: props.copy.status === 'COPYING', onClick: function () { return props.toggleCopyModal(props.copy.data.copyFrom); } }))));
});
